<template lang="html">
    <section v-if="tarifas.length > 0" class="tarifas-result-container">
        <section class="container tarifas-result-content">
            <div class="row-start title">
                <h2>
                    <span class="-orange row-start">iner</span>
                    <span class="-dark">{{ $t('newSimulador.resultView.resultTarifas.title') }}</span>
                </h2>
            </div>

            <div class="row-around grid">
                <article class="tarifa-card" v-for="(tarifa, index) in tarifas" :key="`${tarifa.fee.id}-${index}`">
                    <div class="icon">
                        <img src="/static/img/selector-estandar.svg" alt="">
                    </div>
                    <p class="label -orange">{{ 'ESTANDAR' }}</p>
                    <h4 class="name">{{ tarifa.fee.name }}</h4>
                    <h3 class="price -orange">{{ tarifa.cost_anual }}<span>€</span></h3>
                    <p class="-purple">{{ $t('newSimulador.resultView.resultTarifas.year') }}</p>
                    <h3 class="saving -dark">{{ tarifa.saving_anual }}<span>€</span></h3>
                    <p class="-purple saving-text">{{ $t('newSimulador.resultView.resultTarifas.saving') }}</p>
                    <router-link target="_blank"
                        :to="$t('enlaces.inergizate') + '?suministro=luz&tarifa=' + tarifa.fee.slug + '&tipo=fixed'"
                        title="Contrata" class="btn -degree">
                        {{ $t('elijoEstaOpcion') }}
                    </router-link>
                </article>
            </div>
            <img src="/static/img/confeti-naranja.svg" class="figuras-naranjas">
        </section>
    </section>
</template>

<script lang="js">
export default {
    name: 'result-tarifas',
    props: ['results'],
    data() {
        return {
            tarifas: [],
        };
    },
    watch: {
        results: {
            handler() {
                this.setTarifas();
            },
            immediate: true,
        },
    },
    methods: {
        setTarifas() {
            const list = Array.isArray(this.results) ? this.results : [];
            this.tarifas = list;
        },
    },
}
</script>

<style scoped lang="scss">
@import '@/assets/css/colors.scss';

.tarifas-result-container {
    background: linear-gradient(to bottom, #f9f7fc, #f9f7fc);
    padding-top: 40px;
    padding-bottom: 80px;
}

.tarifas-result-content {
    position: relative;

    .title {
        margin-bottom: 25px;

        h2 {
            width: 100%;
            text-transform: uppercase;
            margin-bottom: 0;
        }
    }

    .grid {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        align-items: center;
        justify-content: center;
        gap: 2.2rem;
        margin-top: 50px;
    }
}

.tarifa-card {
    min-width: 280px;
    min-height: 320px;
    border: 2px solid $orange;
    text-align: center;
    padding: 20px;
    background: white;
    position: relative;

    .icon {
        margin-bottom: 8px;
        position: absolute;
        top: -80px;
        left: 50%;
        transform: translateX(-50%);

        img {
            width: 70px;
            height: 70px;
            object-fit: contain;
        }
    }

    .label {
        text-transform: uppercase;
        margin: 0;
        font-weight: 700;
    }

    .name {
        text-transform: uppercase;
        margin-bottom: 10px;
        color: #EB5F0C;
        font-size: 28px;
    }

    .price {
        line-height: 1em;
        margin: 0;
        font-size: 58px;

        span {
            font-size: 28px;
        }
    }

    .saving {
        line-height: 1em;
        margin-bottom: 6px;
        font-size: 52px;

        span {
            font-size: 28px;
        }
    }

    .saving-text {
        margin-bottom: 0px;
    }

    .btn {
        position: absolute;
        margin-top: auto;
        font-size: 11px;
        padding: 0 20px;
        min-width: 170px;
        bottom: -20px;
        left: 50%;
        transform: translateX(-50%);
        width: 70%;
    }
}

.figuras-naranjas {
    position: absolute;
    right: 0;
    bottom: -140px;
}

@media screen and (max-width: 767px) {
    .tarifas-result__header {
        justify-content: center;
        text-align: center;
    }

    .tarifa-card {
        width: 100%;
        max-width: 320px;
        min-height: 340px;

        .icon {
            display: none;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/view-parts/simulador/result-tarifas.vue